import { Divider } from 'antd'
import { FC } from 'react'

import { SVGs } from '../../../../../assets'
import { IMGs } from '../../../../../assets/img'
import { BitazzaModal, BitazzaText } from '../../../../../components'
import { appCallbackHandler } from '../../../../../util/AppCallbackHandler'
import { getAvatarImage } from '../../../../../util/getAvatar'

import Styles from './StatisticsBox.module.scss'
import { dataType } from './StatisticsBoxes'
import { getColor } from '../../../../../util/getColor'
import { useTranslation } from 'react-i18next'
import { getBadges } from '../../../../../util/getBadges'

interface Props {
    isModalOpen: boolean
    onCLoseModal: () => void
    size?: string
    userData?: usersRequest
    data?: dataType
}

export const StatisticModal: FC<Props> = ({
    isModalOpen,
    onCLoseModal,
    data,
    userData,
}) => {
    const { t } = useTranslation()

    console.log(data, 'data')

    return (
        <BitazzaModal
            size="370px"
            style={{
                overflow: 'hidden',
                backgroundImage: `url(${IMGs.bgModal})`,
                backgroundSize: '100%',
            }}
            onCancel={onCLoseModal}
            isModalOpen={isModalOpen}
            closable={false}
            footer={
                <div className={Styles.button} onClick={onCLoseModal}>
                    <div className={Styles.close}>
                        <BitazzaText
                            format="t18"
                            color="#FFF"
                            content={t('txt_close')}
                            bold
                        />
                    </div>
                    <div
                        className={Styles.share}
                        onClick={() => appCallbackHandler('sendSharing', data)}
                    >
                        <img src={SVGs.share} alt="share" />
                        <BitazzaText
                            format="t18"
                            color="#FFF"
                            content="Share"
                            bold
                        />
                    </div>
                </div>
            }
        >
            <div>
                <div className={Styles.headerWrapper}>
                    <div className={Styles.headerContainer}>
                        <img src={SVGs.btzHeaderLogo} alt="logo" />
                        <BitazzaText
                            content={t('txt_trading_simulator')}
                            format="t18"
                            color="#F1D87E"
                            letterSpacing={2}
                            bold
                        />
                    </div>
                    <div className={Styles.badgeWrapper}>
                        <img src={getBadges(data?.badge || '')} alt="badge" />
                    </div>
                </div>
                <div className={Styles.containerModal}>
                    {userData && (
                        <div className={Styles.avatarWrapper}>
                            <img
                                src={getAvatarImage(userData.tier?.name)}
                                alt="name"
                            />
                            <BitazzaText
                                content={
                                    userData.additional_user_info?.profileName
                                }
                                format="t18"
                                color="#FFFFFF"
                                letterSpacing={2}
                                bold
                            />
                        </div>
                    )}
                    <div className={Styles.textWrapper}>
                        {data && (
                            <>
                                <div>
                                    <BitazzaText
                                        content={
                                            'MY ' + data.label1?.toUpperCase()
                                        }
                                        format="t14"
                                        color="#FFFFFF"
                                        letterSpacing={1}
                                        bold
                                    />{' '}
                                    <BitazzaText
                                        content={data.label2?.toUpperCase()}
                                        format="t14"
                                        color="#FFFFFF"
                                        letterSpacing={1}
                                        display="inline"
                                        bold
                                    />
                                </div>

                                {data.performance &&
                                    data.performance !== 'undefined%' && (
                                        <div
                                            className={
                                                Styles.performanceWrapper
                                            }
                                        >
                                            <div>
                                                <BitazzaText
                                                    content={data.performance}
                                                    format="t56"
                                                    color={getColor(
                                                        data.actualperformance
                                                    )}
                                                    display="inline"
                                                    semiBold
                                                    lineHeight={73}
                                                />
                                            </div>
                                            <div>
                                                <BitazzaText
                                                    content={data.coin || ''}
                                                    format="t16"
                                                    color="#86A1A1"
                                                    semiBold
                                                />
                                            </div>
                                        </div>
                                    )}

                                {/* <Divider className={Styles.divider} /> */}
                                {data.compared && data.performance !== 0 && (
                                    <>
                                        {/* <BitazzaText
                                            content={'MY PERFORMANCE LEVEL'}
                                            format="t16"
                                            color="#FFFFFF"
                                            letterSpacing={2}
                                            semiBold
                                        /> */}
                                        <BitazzaText
                                            content={data.compared}
                                            format="t16"
                                            color="#86A1A1"
                                            lineHeight={16}
                                            display="block"
                                        />
                                    </>
                                )}

                                <BitazzaText
                                    content={data.description}
                                    format="t16"
                                    color="#86A1A1"
                                    lineHeight={16}
                                    display="block"
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Divider className={Styles.dividerText} />
        </BitazzaModal>
    )
}
